import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import _ from 'lodash'

const CustomChatInput = styled.textarea`
    width: 100%;
    overflow: hidden;
    resize: none;
    height: 34px;
    border: 1px solid ${props => props.usedInModal === 'true' ? 'lightgrey !important' : props.borderColor};
    border-radius: 10px;
	font-size: 14px !important;
    padding: ${props => props.usedInModal === 'true' ? '11px 16px !important' : '6px 8px'};

    :focus {
        outline: ${props => props.usedInModal === 'true' ? 'auto' : 'none'};
    }
`

const ChatInput = (props) => {
    const { auth, value, setValue, disabled, usedInModal, textareaRef, chat, clearChatTextInput } = props
    const classes = usedInModal ? 'form-control' : ''
    const {
        content_color
    } = auth.appSettings

    useEffect(() => {
        // Adjust the height of the textarea to fit the content
        if (_.isEmpty(textareaRef) === false) {
            if (value === '') {
                // Reset to default height when input is cleared
                textareaRef.current.style.height = '34px'
                textareaRef.current.style.overflow = 'hidden'
            } else {
                textareaRef.current.style.height = 'auto'
                const scrollHeight = textareaRef.current.scrollHeight
                const maxHeight = 120
                if (scrollHeight <= maxHeight) {
                    textareaRef.current.style.overflow = 'hidden'
                    textareaRef.current.style.height = `${scrollHeight}px`
                } else {
                    textareaRef.current.style.overflow = 'scroll'
                    textareaRef.current.style.height = `${maxHeight}px`
                }
            }
        }
    }, [value])

    useEffect(() => {
        if (chat && chat.clearChatInputText === true) {
            clearChatTextInput(false)
            setValue('')
        }
    }, [chat.clearChatInputText])

    return (
        <CustomChatInput
            id='custom-chat-input'
            ref={textareaRef}
            value={value}
            onChange={(e) => { setValue(e.target.value) }}
            borderColor={props.borderColor || content_color}
            rows={1}
            disabled={disabled}
            placeholder='Write a message...'
            className={classes}
            usedInModal={usedInModal ? 'true' : 'false'}
        />
    )
}

ChatInput.propTypes = {
    auth: PropTypes.object.isRequired,
    value: PropTypes.string.isRequired,
    setValue: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    textareaRef: PropTypes.any,
    usedInModal: PropTypes.bool,
    borderColor: PropTypes.string,
    chat: PropTypes.object.isRequired,
    clearChatTextInput: PropTypes.func.isRequired
}

export default ChatInput
